import {List} from "antd";
import {useEffect, useState} from "react";
import ApiService from "../services/ApiService";

export default function Tutorial() {
    const [help, setHelp] = useState('')
    const [titles, setTitles] = useState([])

    const processHtml = ({html}) => {
        const doc = document.createElement('div');
        doc.innerHTML = html

        const h3List = doc.querySelectorAll('h3')
        const _titles = []
        Array.from(h3List).forEach(x => {
            _titles.push(x.innerText)
            x.id = x.innerText
        })

        setHelp(doc.innerHTML)
        setTitles(_titles)
    }

    const getHelp = async () => {
        const res = await ApiService.RasCheck.GetHelpContent();
        if(res.success){
            // setHelp(res.data)
            processHtml({html: res.data})
        }
    }

    useEffect(() => {
        getHelp()
    }, []);

    return (
        <>
            <div style={{display: 'flex', gap: 8}}>
                <List
                    style={{width: 400}}
                    dataSource={titles}
                    size={'small'}
                    bordered={true}
                    renderItem={(item) => (
                        <List.Item>
                            <a href={`#${item}`}>
                                {item}
                            </a>
                        </List.Item>
                    )}
                />
                <div style={{width: '100%', padding: 8, height: window.innerHeight-300, overflowX: 'auto'}}>
                    {
                        help && (
                            <div id={'info-panel'} dangerouslySetInnerHTML={{__html: help}}>

                            </div>
                        )
                    }
                </div>
            </div>
        </>
    )
}